import { ref } from "vue";

/**
 * ウィンドウZインデックスリスト
 */
export const windowDialogZIndexList = ref([]);

export const windowDialogBaseZIndex = 100;

export const windowDialogImportantIndex = 900;

/**
 * ウィンドウ位置重なり回避対象リスト
 */
export const windowDialogAvoidOverlapList = ref([]);
